<template>
    <el-card shadow="never">

        <div slot="header" class="clearfix" style="font-weight: bold; font-size: 20px">
            <span v-if="$store.getters.getUser.status === 'on_moderation'">{{ $t('on_moderation_title') }}</span>
            <span v-if="$store.getters.getUser.status === 'not_active'">{{ $t('activation_title') }}</span>
        </div>

        <div v-if="$store.getters.getUser.status === 'on_moderation'">
            <div style="margin-bottom: 15px">{{ $t('on_moderation_descr') }}</div>

            <div style="margin-bottom: 15px">Сразу предоставьте информацию менеджеру о ваших источниках трафика, объемах и примерах рекламных материалов.</div>

            <div style="margin-bottom: 15px; font-weight: bold"><span style="color: red">ВНИМАНИЕ!</span> Мы не платим за фродовый трафик – в случае выявления мошейничества ваш аккаунт будет заблокирован навсегда и никакого диалога с фродерами у нас нет.</div>

            <div style="margin-top: 15px">

                <el-button type="default" @click="tg" round plain>
                    <img src="../assets/telegram.svg" style="height: 20px; margin-right: 7px;" />
                    Написать в Телеграм
                </el-button>
            </div>
        </div>

        <div v-if="$store.getters.getUser.status === 'not_active'">
            {{ $t('activation_descr') }}
        </div>

    </el-card>
</template>

<script>
    export default {
        name: "Activation",
        beforeRouteEnter (to, from, next) {
            next(vm => {
                if (!vm.$store.getters.isAuthenticated) {
                    next({
                        name: 'main'
                    })
                }
            })
        },
        watch: {
            '$store.getters.getUser.status': {
                handler () {
                    if (this.$store.getters.getUser.status === 'active') {
                        this.$router.replace({ name: 'main' })
                    }
                },
                deep: true
            },
        },
        created () {
            this.$store.dispatch("getUser");
        },
        methods: {
            tg() {
                window.open("tg://resolve?domain=lovepartnersbiz");
            }
        }
    }
</script>

<style lang="scss" scoped>
    .el-card {
        margin-left: auto;
        margin-right: auto;
        width: 700px;
        .el-alert {
            margin-top:10px;
        }
        text-align: center;
    }
</style>